const AIEmailGeneratorEndpoints = {
	askEmailGenerator(data: any) {
		return {
			url: 'emailgeneration/ask',
			headers: data.headers,
			data: data.reqBody,
		};
	},
	humanFeedback(data: any) {
		return {
			url: 'emailgeneration/human_feedback',
			headers: data.headers,
			data: data.reqBody,
		};
	},
	sendObjectives(data: any) {
		return {
			url: 'emailgeneration/objectives ',
			headers: data.headers,
			data: data.reqBody,
		};
	},
	getObjectiveSuggestions(data: any) {
		return {
			url: 'emailgeneration/objective_suggestions ',
			headers: data.headers,
			data: data.reqBody,
		};
	},
	styleGuide(data: any) {
		return {
			url: 'emailgeneration/upload_style_guide',
			headers: data.headers,
			data: data,
		};
	},
	fetchSegment(data: any) {
		return {
			url: 'dataenrichment/segment_fetch',
			headers: data.headers,
			data: data,
		};
	},
	storeEmailLogs(data: any) {
		return {
			url: 'emailgeneration/store_email_logs',
			headers: data.headers,
			data: data,
		};
	},
	getEmailLogs(data: any) {
		return {
			url: 'emailgeneration/get_email_logs',
			headers: data.headers,
			data: data,
		};
	},
	filterEmails(data: any) {
		return {
			url: 'emailgeneration/filter_emails',
			headers: data.headers,
			data: data,
		};
	},
	getEmailNames(data: any) {
		return {
			url: 'emailgeneration/get_email_names',
			headers: data.headers,
			data: data,
		};
	},
};

export default AIEmailGeneratorEndpoints;
